import React from 'react'

function Footer() {

    return (
      <div className='footer-page'>
        <div className="credit-grid">
          <div>
            <div>CLK Psychotherapy PLLC</div>
            <div>5547 N Ravenswood Ave, Suite 407</div>
            <div>Chicago*, IL 60640</div>
          </div>
          <div>
            <div>Illinois Licensed Clinical Social Worker (LCSW), License Number: 149.024234</div>
            <div>Illinois Professional Limited Liability Company (PLLC), License Number: 248.004022</div>
          </div>
        </div>
        <div className="credit">
          <span>Land Acknowledgement: I reside on the traditional homelands of the people of the Council of Three Fires, the Ojibwe, Potawatomi, and Odawa as well as the Menominee, Miami and Ho-Chunk nations. <a href="https://www.youtube.com/watch?v=ETOhNzBsiKA" target="_blank"><u>Watch here</u></a> to understand why I make this acknowledgement.</span>
        </div>



        <div className="credit">Website designed and built by <a href="http://www.aemard.com" target="_blank">An Emard</a>.</div>
      </div>
    )
}

export default Footer